import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export const PayPalCheckout = ({ plan, onSuccess }) => {
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
  const [planId, setPlanId] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let active = true;
    setPlanId(null);
    setErr(null);
    api
      .get(`/paypal/subscription-plan/${plan}`)
      .then((r) => active && setPlanId(r.data.plan_id))
      .catch((e) => active && setErr(apiError(e)));
    return () => { active = false; };
  }, [plan]);

  if (!clientId) return <p className="text-sm text-slate-400 text-center">PayPal is not configured.</p>;
  if (err) return <p className="text-sm text-red-500 text-center py-4" data-testid="paypal-error">{err}</p>;
  if (!planId) return <p className="text-sm text-slate-400 text-center py-4">Loading PayPal…</p>;

  return (
    <div data-testid="paypal-checkout">
      <PayPalScriptProvider options={{ clientId, vault: true, intent: "subscription" }}>
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill", color: "gold", label: "subscribe" }}
          createSubscription={(data, actions) => actions.subscription.create({ plan_id: planId })}
          onApprove={async (data) => {
            try {
              const { data: res } = await api.post("/paypal/activate-subscription", {
                plan,
                subscription_id: data.subscriptionID,
              });
              if (res.payment_status === "paid") {
                toast.success("Subscription active — your plan is upgraded!");
                onSuccess?.(res.plan);
              } else {
                toast.error("Subscription is pending PayPal approval. Try again shortly.");
              }
            } catch (e) {
              toast.error(apiError(e));
            }
          }}
          onError={() => toast.error("PayPal error. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};
